import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'piTooltipMessage',
})
export class PiTooltipMessagePipe implements PipeTransform {
  transform(
    value: string[] | null,
    customLabelClass: string,
    customListClass: string,
  ) {
    if (!value || value.length === 0) {
      return '';
    }

    if (value.length === 1) {
      return value[0];
    }
    return `
     <p class="${customLabelClass}" >PRINCIPAL INVESTIGATORS:</p>

     ${this._constructUnOrderedList(value, customListClass)}
    `;
  }

  private _constructUnOrderedList(value: string[], listClass: string) {
    const _listItems = value.toSorted((a, b) => a.localeCompare(b));
    return `<ul class="${listClass}">${_listItems
      .map(
        (item) => `<li class="${listClass}">${item.split(',').join(',')}</li>`,
      )
      .join('')}</ul>`;
  }
}
